import React from 'react';
import PropTypes from 'prop-types';

const Share = ({
	fill = '#9B9B9B',
	...props
}) =>
	<svg fill={fill} width="25" height="24" viewBox="0 0 25 24" {...props}>
		<path d="M24.707,0 L24.707,11 L19.914,6.207 L13.414,12.707 L12,11.293 L18.5,4.793 L13.707,0 L24.707,0 Z M23,24 L1,24 C0.448,24 0,23.552 0,23 L0,1 C0,0.448 0.448,0 1,0 L10,0 L10,2 L2,2 L2,22 L22,22 L22,14 L24,14 L24,23 C24,23.552 23.552,24 23,24 Z"/>
	</svg>;

Share.propTypes = {
	fill: PropTypes.string
};

export default Share;
